import React from "react";
import Modal from "../../commonComponents/util/Modal";
import ValidatedInput from "../../commonComponents/util/ValidatedInput";
import LoadingSpinner from "../../commonComponents/util/LoadingSpinner";
import FadeOutErrorMessage from "../../commonComponents/util/FadeOutErrorMessage";

export default class TransactionTypeModal extends React.Component {
  state = {
    error: false,
    submitAttempted: false,
    value: ""
  };

  componentWillReceiveProps(nextProps) {
    if (nextProps.show && !this.props.show && nextProps.transactionType) {
      this.setState({
        value: nextProps.transactionType.value
      });
    }
  }

  onChange = (name, value) => {
    this.setState({ [name]: value });
  };

  onClose = () => {
    this.setState({
      error: false,
      submitAttempted: false,
      value: ""
    });
    this.props.close();
  };

  onSave = async () => {
    this.setState({
      error: false,
      submitAttempted: true
    });

    if (!this.state.value) return;

    await this.props.save(
      this.props.transactionType
        ? {
            ...this.props.transactionType,
            value: this.state.value
          }
        : this.state.value
    );
    if (this.props.success) {
      this.onClose();
    } else {
      this.setState({ error: true });
    }
  };

  render() {
    const { show, title, transactionType } = this.props;
    const { error, value, submitAttempted } = this.state;
    
    return (
      <Modal modalShowing={show}>
        <div className="modal-container">
          <div className="modal new-fund-modal large-modal">
            <div className="modal-header">
              <h4 className="page-header">
                {transactionType ? "Edit" : "New"} {title}
              </h4>
              <i className="icon ion-ios-close-empty" onClick={this.onClose} />
            </div>
            <div className="modal-section">
              <ValidatedInput
                input={<input type="text" />}
                label={title}
                name="value"
                onChange={this.onChange}
                required={true}
                showRequiredError={submitAttempted}
                value={value}
              />
            </div>
            {this.props.loading ? (
              <LoadingSpinner alignRight={true} height={20} />
            ) : (
              <div className="modal-btns text-right">
                <button className="btn btn-accent" onClick={this.onClose}>
                  Cancel
                </button>
                <button
                  className="btn btn-primary"
                  onClick={this.onSave}
                  disabled={
                    !value || (transactionType && transactionType === value)
                  }
                >
                  Save
                </button>
                <FadeOutErrorMessage show={error} />
              </div>
            )}
          </div>
        </div>
      </Modal>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/accountingComponents/fundsCommon/TransactionTypeModal.jsx